import { Snackbar } from 'components/Snackbar';
import { useTreatmentOnGoing } from 'context';
import { FC, useEffect, useMemo, useState } from 'react';
import { io } from 'socket.io-client';
import { SocketTreatmentEvents } from 'types';
import { getUserToken } from 'util/auth';

import { AlertColor, Card, CardMedia, Paper } from '@mui/material';

interface ISnackbar {
  message: string | null;
  variant?: AlertColor | undefined;
}

export const VideoCall: FC = () => {
  const { treatmentOnGoing } = useTreatmentOnGoing();

  const [snackbar, setSnackbar] = useState<ISnackbar>({
    message: '',
    variant: 'info',
  });

  const socket = useMemo(() => {
    return io(process.env.REACT_APP_BASE_API_URL as string, { path: '/ws' });
  }, []);

  useEffect(() => {
    if (treatmentOnGoing?.roomId) {
      socket.on('connect', () => {
        socket.emit(SocketTreatmentEvents.TUTOR_TREATMENT_VET_JOINING_ROOM, {
          roomId: treatmentOnGoing.roomId,
        });

        socket.on(SocketTreatmentEvents.TUTOR_TREATMENT_ACCEPT_CALL, () => {
          setSnackbar({
            variant: 'success',
            message: 'Tutor aceitou a chamada',
          });
        });

        socket.on(SocketTreatmentEvents.TUTOR_TREATMENT_REJECT_CALL, () => {
          setSnackbar({
            variant: 'error',
            message: 'Tutor rejeitou a chamada',
          });
        });
      });

      socket.connect();
    }

    return () => {
      socket.removeAllListeners();
      socket.disconnect();
    };
  }, [socket, treatmentOnGoing?.roomId]);

  if (!treatmentOnGoing.id) {
    return null;
  }

  const { callUrl } = treatmentOnGoing;

  return (
    <>
      <Paper
        sx={{
          border: '1px solid #FBB45F',
          boxShadow:
            '0px 1px 5px rgba(0, 0, 0, 0.2), 0px 3px 4px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.14)',
        }}
      >
        <Card
          sx={{
            border: '5px solid #000000',
            minHeight: 375,
          }}
        >
          <CardMedia
            sx={{ height: 375 }}
            component="iframe"
            image={`${callUrl}?jwt=${getUserToken().token}`}
            allow="camera; microphone; fullscreen; display-capture; autoplay"
          />
        </Card>
      </Paper>

      <Snackbar
        text={snackbar.message}
        snackbarOpen={Boolean(snackbar.message)}
        setSnackbarOpen={() => {
          setSnackbar({
            message: '',
          });
        }}
        severityType={snackbar.variant}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      />
    </>
  );
};
